import type { UseQueryResult } from "@tanstack/react-query";
import { assertNever } from "utils/hx/util/types";
import { error, type LoadingValue, loaded, loading } from "utils/utility-types";

export const fromUseQueryResult = <T>(
  queryResult: UseQueryResult<T>,
): LoadingValue<T> => {
  if (queryResult.error != null) return error(queryResult.error as Error);
  if (queryResult.data != null) return loaded(queryResult.data);
  return loading();
};

export const match =
  <T, R = T>({
    loading,
    error,
    loaded,
  }: {
    loading: () => R;
    error: (err: Error) => R;
    loaded: (ok: T) => R;
  }) =>
  (val: LoadingValue<T>): R => {
    switch (val.state) {
      case "error":
        return error(val.error);
      case "loading":
        return loading();
      case "success":
        return loaded(val.value);
      default:
        assertNever(val);
    }
  };

export const get = <T>(lvt: LoadingValue<T>) =>
  match<T, T | undefined>({
    loading: () => undefined,
    error: () => undefined,
    loaded: (ok) => ok,
  })(lvt);
